export default __webpack_public_path__ + "static/media/linesLeft.35f2ada2.png";